export const RECEIVE_EVENTLOGS = 'RECEIVE_EVENTLOGS';
export const RECEIVE_EVENTLOG = 'RECEIVE_EVENTLOG';
export const ERROR = 'ERROR';
export const SET_FILTER = 'SET_FILTER';
